<template>
  <div id="app">
    <loading v-show="LOADING"></loading>
    <router-view></router-view>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import Loading from './components/LoadingGif'
import { getUrlKey } from './assets/js/data.js'
export default {
  name: 'App',
  computed: {
    ...mapState([
      'LOADING'
    ])
  },
  components: {
    Loading
  },
  created () {
    let hash = window.location.href
    console.log('hash', hash)
    sessionStorage.setItem('parentAgentId', getUrlKey('parentAgentId', hash))
    sessionStorage.setItem('parentAgengName', getUrlKey('parentAgengName', hash))
    sessionStorage.setItem('parentMobile', getUrlKey('parentMobile', hash))
  }
}
</script>

<style lang="scss" scoped>
</style>
